var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Autocomplete, Avatar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, TextField, Typography, debounce } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { Delete02Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { PatternFormat } from 'react-number-format';
import { useLazyGetCompanyQuery, useUpdateCompanyMutation } from '../../../../application/features/companies/company-api';
import { graphApi } from '../../../../application/features/microsoft-graph/microsoft-graph-api';
import { useLazyGetLocationQuery, useLazySearchAddressLocationQuery } from '../../../../application/features/pdok/pdok-api';
import useTranslate from '../../../../localization/helpers';
var UpdateCompany = function (_a) {
    var _b;
    var companyId = _a.companyId, open = _a.open, onClose = _a.onClose;
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField, tWithFunction = _c.tWithFunction;
    var _d = __read(useState(null), 2), imageSrc = _d[0], setImageSrc = _d[1];
    var _e = __read(useState(''), 2), locationSearchTerm = _e[0], setLocationSearchTerm = _e[1];
    var _f = __read(useState(''), 2), fileError = _f[0], setFileError = _f[1];
    var _g = __read(useLazyGetCompanyQuery(), 2), triggerGetCompany = _g[0], _h = _g[1], company = _h.data, isCompanyFetching = _h.isFetching;
    var _j = __read(useLazySearchAddressLocationQuery(), 2), triggerSearchLocation = _j[0], _k = _j[1], _l = _k.data, locations = _l === void 0 ? [] : _l, isLocationsFetching = _k.isFetching;
    var _m = __read(useLazyGetLocationQuery(), 1), triggerGetLocation = _m[0];
    var _o = __read(useUpdateCompanyMutation(), 2), updateCompany = _o[0], _p = _o[1], updateCompanyLoading = _p.isLoading, isSuccess = _p.isSuccess;
    var _q = useForm({
        defaultValues: {
            id: '',
            name: '',
            domain: '',
            emailAddress: '',
            phoneNumber: '',
            location: undefined,
            locationId: '',
            locationCode: '',
            locationName: '',
            description: '',
            isLogoDeleted: false,
            logo: null
        }
    }), handleSubmit = _q.handleSubmit, control = _q.control, watch = _q.watch, setValue = _q.setValue, reset = _q.reset, resetField = _q.resetField, errors = _q.formState.errors;
    var uploadedFile = watch('logo');
    useEffect(function () {
        var fetchLogo = function () { return __awaiter(void 0, void 0, void 0, function () {
            var previewUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(company && company.logoPath)) return [3 /*break*/, 2];
                        return [4 /*yield*/, graphApi.getDownloadUrl("".concat(company.logoPath))];
                    case 1:
                        previewUrl = _a.sent();
                        setImageSrc(previewUrl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        fetchLogo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [company]);
    useEffect(function () {
        if (companyId) {
            triggerGetCompany(companyId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId]);
    useEffect(function () {
        if (company) {
            var location_1 = [
                company.locationCode ? company.locationCode : '',
                company.locationName ? company.locationName : ''
            ]
                .filter(Boolean)
                .join(' ');
            reset({
                id: company.id,
                name: company.name,
                domain: company.domain,
                emailAddress: company.emailAddress,
                phoneNumber: company.phoneNumber,
                location: {
                    isFakeId: true,
                    id: nanoid(),
                    weergavenaam: location_1
                },
                locationId: company.locationId,
                locationName: company.locationName,
                locationCode: company.locationCode,
                description: company.description,
                isLogoDeleted: false,
                logo: null
            });
        }
    }, [company, reset]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.company'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            handleClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var getSearchResults = useMemo(function () {
        return debounce(function (searchTerm) {
            if (searchTerm)
                triggerSearchLocation(searchTerm);
        }, 1000);
    }, [triggerSearchLocation]);
    useEffect(function () {
        getSearchResults(locationSearchTerm);
    }, [getSearchResults, locationSearchTerm]);
    var onLocationChange = function (value) {
        if (value) {
            triggerGetLocation(value.id)
                .unwrap()
                .then(function (location) {
                var _a;
                setValue("locationId", location.id);
                setValue("locationCode", location.postcode);
                setValue("locationName", (_a = location.woonplaatsnaam) !== null && _a !== void 0 ? _a : location.weergavenaam);
            });
        }
    };
    var handleClose = function () {
        reset();
        setImageSrc(null);
        setFileError('');
        onClose();
    };
    var onImageUpload = function (file) {
        var uploadedFile;
        if (file instanceof FileList) {
            uploadedFile = file[0];
        }
        else if (Array.isArray(file)) {
            uploadedFile = file[0];
        }
        else {
            uploadedFile = file;
        }
        var localUrl = URL.createObjectURL(uploadedFile);
        setImageSrc(localUrl);
        setValue('logo', uploadedFile);
        setFileError('');
    };
    var onImageDelete = function () {
        setImageSrc(null);
        resetField('logo');
        setValue('isLogoDeleted', true);
    };
    var fileTypeError = function () { return setFileError(translate('companies.fileTypeError')); };
    var fileSizeError = function () { return setFileError(translate('companies.fileSizeError')); };
    var onSubmit = function (company) {
        updateCompany(company);
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'xs', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [tWithFunction('actions.updateFunction', 'common.company'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: handleClose, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { dividers: true, sx: {
                    overflowX: 'clip',
                    pb: 4
                }, children: _jsxs(Box, { component: 'form', noValidate: true, autoComplete: 'off', children: [_jsx(Box, { display: 'flex', width: '100%', justifyContent: 'center', children: imageSrc && imageSrc !== '' ? (_jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '144px', height: '144px', position: 'relative', borderRadius: '50%', zIndex: 60, border: '1px dashed #919EAB33', children: [_jsx(IconButton, { onClick: onImageDelete, sx: {
                                            '&:hover': {
                                                backgroundColor: 'gainsboro'
                                            },
                                            position: 'absolute',
                                            bottom: 12,
                                            right: 16,
                                            zIndex: 70,
                                            backgroundColor: 'gainsboro',
                                            borderRadius: '50%',
                                            padding: '4px'
                                        }, children: _jsx(Delete02Icon, { size: 16, color: '#FF0000' }) }), _jsx(Avatar, { src: imageSrc, sx: { width: 128, height: 128, '& .MuiAvatar-img': { objectFit: 'contain' } } })] })) : (_jsx(FileUploader, { fileOrFiles: uploadedFile, handleChange: onImageUpload, types: ['JPG', 'JPEG', 'PNG'], disabled: updateCompanyLoading || isCompanyFetching, maxSize: 30, onTypeError: fileTypeError, onSizeError: fileSizeError, children: _jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '144px', height: '144px', position: 'relative', borderRadius: '50%', zIndex: 60, border: '1px dashed #919EAB33', children: [_jsxs(Box, { zIndex: 50, display: 'flex', width: '128px', height: '128px', borderRadius: '50%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 6, left: 6, gap: 1, sx: {
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                cursor: 'pointer'
                                            }, children: [_jsx(Icon, { icon: 'solar:camera-add-bold', fontSize: 24, color: 'white' }), _jsx(Typography, { variant: 'caption', color: 'white', children: translate('companies.uploadLogo') })] }), _jsx(Avatar, { src: '/images/avatar1.png', sx: { width: 76, height: 76 } })] }) })) }), _jsx(FormHelperText, { error: true, sx: { textAlign: 'center', mt: 0 }, children: fileError }), _jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'name', control: control, rules: {
                                            required: {
                                                value: true,
                                                message: tWithField('validations.fieldIsRequired', 'common.name')
                                            },
                                            maxLength: {
                                                value: 256,
                                                message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                            }
                                        }, render: function (_a) {
                                            var _b;
                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                            return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { value: value, onChange: onChange, error: !!errors.name, disabled: updateCompanyLoading || isCompanyFetching, margin: 'dense', label: translate('common.name'), type: 'text', fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                                        } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'location', control: control, rules: {
                                            required: {
                                                value: true,
                                                message: tWithField('validations.fieldIsRequired', 'common.location')
                                            }
                                        }, render: function (_a) {
                                            var _b;
                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                            return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), fullWidth: true, disabled: updateCompanyLoading || isCompanyFetching, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.weergavenaam; }, options: locations, loading: isLocationsFetching, onChange: function (_, value) {
                                                            onChange(value);
                                                            onLocationChange(value);
                                                        }, onInputChange: function (event, value) {
                                                            if ((event === null || event === void 0 ? void 0 : event.type) === 'change') {
                                                                setLocationSearchTerm(value);
                                                            }
                                                        }, value: value && value.id ? value : null, renderInput: function (params) {
                                                            var _a;
                                                            return (_jsx(TextField, __assign({ placeholder: 'Type to Search' }, params, { label: translate('common.location'), slotProps: {
                                                                    input: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(Fragment, { children: [isLocationsFetching ? (_jsx(CircularProgress, { color: 'inherit', size: 20 })) : null, (_a = params.InputProps) === null || _a === void 0 ? void 0 : _a.endAdornment] })) })
                                                                }, error: !!errors.location })));
                                                        }, sx: {
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '8px',
                                                                '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                                    padding: '3.5px 4px 3.5px 8px'
                                                                }
                                                            }
                                                        } }), _jsx(FormHelperText, { error: true, children: (_b = errors.location) === null || _b === void 0 ? void 0 : _b.message })] }));
                                        } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'emailAddress', control: control, rules: {
                                            required: {
                                                value: true,
                                                message: tWithField('validations.fieldIsRequired', 'common.email')
                                            },
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: translate('validations.invalidFormat')
                                            },
                                            maxLength: {
                                                value: 128,
                                                message: translate('validations.maximumCharactersAllowed', { count: 128 })
                                            }
                                        }, render: function (_a) {
                                            var _b;
                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                            return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { value: value, onChange: onChange, error: !!errors.emailAddress, disabled: updateCompanyLoading || isCompanyFetching, margin: 'dense', label: translate('common.email'), type: 'text', fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.emailAddress) === null || _b === void 0 ? void 0 : _b.message })] }));
                                        } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'domain', control: control, rules: {
                                            required: {
                                                value: true,
                                                message: tWithField('validations.fieldIsRequired', 'common.domain')
                                            },
                                            pattern: {
                                                value: /^[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: translate('validations.invalidFormat')
                                            },
                                            maxLength: {
                                                value: 128,
                                                message: translate('validations.maximumCharactersAllowed', { count: 128 })
                                            }
                                        }, render: function (_a) {
                                            var _b;
                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                            return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { value: value, onChange: onChange, error: !!errors.domain, disabled: updateCompanyLoading || isCompanyFetching, margin: 'dense', label: translate('common.domain'), type: 'text', fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.domain) === null || _b === void 0 ? void 0 : _b.message })] }));
                                        } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'phoneNumber', control: control, rules: {
                                            required: {
                                                value: true,
                                                message: tWithField('validations.fieldIsRequired', 'common.phone')
                                            },
                                            pattern: {
                                                value: /^\+31(?!0)\d{9}$/,
                                                message: translate('validations.invalidFormat')
                                            },
                                            maxLength: {
                                                value: 20,
                                                message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                            }
                                        }, render: function (_a) {
                                            var _b;
                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                            return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(PatternFormat, { allowEmptyFormatting: true, customInput: TextField, value: value, disabled: updateCompanyLoading || isCompanyFetching, onChange: onChange, margin: 'dense', label: translate('common.phone'), type: 'tel', fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } }, format: '+31#########', isAllowed: function (values) {
                                                            return (!values.value ||
                                                                (values.floatValue !== undefined && values.floatValue > 0));
                                                        }, error: !!errors.phoneNumber }), _jsx(FormHelperText, { error: true, children: (_b = errors.phoneNumber) === null || _b === void 0 ? void 0 : _b.message })] }));
                                        } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(Controller, { name: 'description', control: control, rules: {
                                                    maxLength: {
                                                        value: 1000,
                                                        message: translate('validations.maximumCharactersAllowed', { count: 1000 })
                                                    }
                                                }, render: function (_a) {
                                                    var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                                    return (_jsx(TextField, { value: value, onChange: onChange, error: !!errors.description, margin: 'dense', disabled: updateCompanyLoading || isCompanyFetching, label: translate('common.description'), type: 'text', multiline: true, minRows: 5, fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } } }));
                                                } }), _jsx(FormHelperText, { error: true, children: (_b = errors.description) === null || _b === void 0 ? void 0 : _b.message })] }) })] })] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: updateCompanyLoading, size: 'medium', variant: 'outlined', color: 'inherit', onClick: handleClose, children: translate('actions.cancel') }), _jsx(Button, { disabled: updateCompanyLoading, size: 'medium', variant: 'contained', color: 'warning', onClick: handleSubmit(onSubmit), children: translate('actions.saveChanges') })] })] }));
};
export default UpdateCompany;
